import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    minHeight: '95vh',
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  logoCompany: {
    height: '7vw',
    maxHeight: '8vw',
    margin: '3vh',
  },
  buttonCompany: {
    margin: theme.spacing(1),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}));
